import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import { getUrlFriendly } from './RouteResolver';
import styles from './enllac.module.scss';
import { forwardRef } from 'react';

const _getUrl = (props) => {
    const { type, route } = props;
    return getUrlFriendly({ ...props, ...route, routePath: route?.type || type });
};

const isInternalLink = (url) => {
    return url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/3catinfo/') && !url.startsWith('/3cat/');
};

const Enllac = forwardRef((props, ref) => {
    const {
        className,
        route,
        rel,
        dataTestId,
        ariaLabel,
        ariaCurrent,
        ariaExpanded,
        title,
        role,
        tabIndex,
        onClick,
        onKeyDown,
        titol = '',
        estil = '',
        href = '',
        novaFinestra = false
    } = props;

    const styleLink = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let hrefLink = route?.href || href;
    if (__isEmpty(hrefLink)) {
        hrefLink = _getUrl(props);
    }

    const linkContent = (
        <a
            onClick={onClick}
            onKeyDown={onKeyDown}
            className={styleLink || null}
            target={novaFinestra ? '_blank' : null}
            rel={novaFinestra ? 'noreferrer' : rel}
            data-testid={dataTestId}
            aria-label={ariaLabel}
            aria-current={ariaCurrent}
            aria-expanded={ariaExpanded}
            title={title}
            role={role}
            href={hrefLink}
            ref={ref}
            tabIndex={tabIndex}
        >
            {titol || props.children}
        </a>
    );
    if (isInternalLink(hrefLink)) {
        /*
            <Link href={hrefLink} scroll={false}>
                {linkContent}
        */
        return (
            <Link
                href={hrefLink}
                scroll={false}
                onClick={onClick}
                onKeyDown={onKeyDown}
                className={styleLink || null}
                target={novaFinestra ? '_blank' : null}
                rel={novaFinestra ? 'noreferrer' : rel}
                data-testid={dataTestId}
                aria-label={ariaLabel}
                title={title}
                role={role}
                ref={ref}
                tabIndex={tabIndex}
            >
                {titol || props.children}
            </Link>
        );
    } else {
        return linkContent;
    }
});

Enllac.displayName = 'Enllac';
export default Enllac;
